<!-- Física -->
<sgt-pessoa-tipo-badge-fisica
    *ngIf="config?.isFisica">
</sgt-pessoa-tipo-badge-fisica>

<!-- Jurídica -->
<sgt-pessoa-tipo-badge-juridica
    *ngIf="config?.isJuridica">
</sgt-pessoa-tipo-badge-juridica>

<!-- Central de Compras -->
<sgt-pessoa-tipo-badge-central-compras
    *ngIf="config?.isCentralCompras"
    [quantidadeParticipantes]="quantidadeParticipantesCentralCompras">
</sgt-pessoa-tipo-badge-central-compras>